import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./translation/en.json";
import viTranslation from "./translation/vi.json";
import cnTranslation from "./translation/cn.json";
import koTranslation from "./translation/ko.json";
import jaTranslation from "./translation/ja.json";
import sinTranslation from "./translation/sin.json";
import thaiTranslation from "./translation/thai.json";
import camTranslation from "./translation/cam.json";
import msTranslation from "./translation/ms.json";

// Khởi tạo i18n

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
    vi: {
      translation: viTranslation,
    },
    ms: {
      translation: msTranslation,
    },
    cn: {
      translation: cnTranslation,
    },
    ko: {
      translation: koTranslation,
    },
    thai: {
      translation: thaiTranslation,
    },
    ja: {
      translation: jaTranslation,
    },
    cam: {
      translation: camTranslation,
    },
    sin: {
      translation: sinTranslation,
    },
  },
  lng: "vi",
  fallbackLng: "vi",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
